type Identity = { personId?: unknown; firstName?: unknown; lastName?: unknown };
type Result = Identity & { id: string; status?: unknown };
const nameKey = (row: Identity) => `${row.firstName || ''} ${row.lastName || ''}`.normalize('NFKC').trim().replace(/\s+/g, ' ').toLowerCase();
const personNumber = (value: unknown) => {
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
};

export function kutcStarterIndex(rows: Result[]) {
  const index = new Map<number, Result>();
  for (const row of rows) {
    const id = personNumber(row.id);
    if (!id || (row.personId != null && personNumber(row.personId) !== id) || index.has(id)) {
      throw new Error('Resultatene har ugyldig eller motstridende person-ID. Avklar koblingen før mottakere velges.');
    }
    index.set(id, row);
  }
  return index;
}

/** Exact canonical identity only. Never infer participation from registration status or bib. */
export type KutcParticipationFilter = 'any' | 'started' | 'finished' | 'dnf' | 'dns';
export function kutcParticipationStatus(
  editionId: string, registration: Identity & { editionId?: string }, user: Identity | undefined,
  results: ReturnType<typeof kutcStarterIndex>, filter: Exclude<KutcParticipationFilter, 'any'>,
): 'Finished' | 'DNF' | 'DNS' | null {
  if (!/^kutc-\d{4}$/.test(editionId)) throw new Error('Velg én KUTC-årsutgave for løpsstatusfilteret.');
  if (registration.editionId !== editionId) return null;
  const explicitId = personNumber(registration.personId);
  const profileId = personNumber(user?.personId);
  const result = results.get(explicitId || profileId || 0);
  const status = String(result?.status || '').trim().toLowerCase();
  if (!result || !(filter === 'started' ? ['finished', 'dnf'] : [filter]).includes(status)) return null;
  if ((explicitId && profileId && explicitId !== profileId) || !nameKey(registration) ||
      nameKey(registration) !== nameKey(result) || (user && nameKey(user) && nameKey(user) !== nameKey(result))) {
    throw new Error(`Personkoblingen for ${nameKey(registration) || 'en påmelding'} stemmer ikke med resultatet. Avklar før utsending.`);
  }
  return status === 'dnf' ? 'DNF' : status === 'dns' ? 'DNS' : 'Finished';
}

export function kutcStarterStatus(editionId: string, registration: Identity & { editionId?: string }, user: Identity | undefined, results: ReturnType<typeof kutcStarterIndex>) {
  return kutcParticipationStatus(editionId, registration, user, results, 'started');
}
